import React from "react";
import cn from "classnames";

import "./TextChip.scss";

export interface TextChipProps {
    content: string;
    /**
     * @default true
     */
    defaultColor?: boolean;
    classNames?: string;
}

const TextChip = ({
    content,
    defaultColor = true,
    classNames,
}: TextChipProps) => (
    <span
        className={cn("ds-text-chip", classNames, {
            "ds-text-chip--default-color": defaultColor,
        })}
    >
        {content}
    </span>
);

export default TextChip;
